import React from 'react'

function Header(){
    return(
      <div className="container-fluid " id="heading1">
        <div className="row justify-content-center">
            <h1>Cloudie</h1>
            <small>Your go to weather buddy</small>
        </div>
      </div>
    )
  }
export default Header;
